// apps/api/src/qxcircle/qxcircle-notification-seeds.ts
// Description: QXCircle notification bootstrap — empty on product.
// Owner: Masa Bayu
// Date: 2026-08-30

import type { QxCircleNotification } from "./qxcircle.types";

export function seedQxCircleNotifications(): QxCircleNotification[] {
  return [];
}
